// 设置动态根字体大小
function setRootFontSize() {
  const designWidth = 1920
  const rootFontSize = (window.innerWidth / designWidth) * 10
  document.documentElement.style.fontSize = `${rootFontSize}px`
}

// 初始化
setRootFontSize()

// 窗口大小变化时重新计算
window.addEventListener('resize', setRootFontSize)
